// extracted by mini-css-extract-plugin
module.exports = {"ImageCarousel":"ImageCarousel_ImageCarousel__ddiwC","cardIntroText":"ImageCarousel_cardIntroText__FhSCC"};